import CalculationsDetailed from './calculations-detailed.entity';
import ItemsSimplified from './items-simplified-entity';

export default class ItemsDetailed extends ItemsSimplified {
  line: string;

  number: string;

  contractNumber: string;

  installment: string;

  businessUnitId: string;

  businessUnitName: string;

  resultCenterName: string;

  value: string;

  calculations: CalculationsDetailed[] = [];

  observation: string;

  constructor(obj: any = {}) {
    super(obj);
    this.line = obj.line || '';
    this.number = obj.number || '';
    this.contractNumber = obj.contractNumber || '';
    this.installment = obj.installment || '';
    this.businessUnitId = obj.businessUnitId || '';
    this.businessUnitName = obj.businessUnitName || '';
    this.resultCenterName = obj.resultCenterName || '';
    this.value = obj.value || '';
    this.observation = obj.observation || '';
    if (obj.calculations) {
      this.calculations = CalculationsDetailed.ofList(
        obj.calculations.map((calculation: any) => ({ ...calculation, itemNumber: obj.number })),
      );
    }
  }

  public static of(obj: any = {}): ItemsDetailed {
    return new ItemsDetailed(obj);
  }

  public static ofList(obj: any[]): ItemsDetailed[] {
    return obj.map(this.of)
  }
}
